// extracted by mini-css-extract-plugin
export var container = "_7o-0";
export var error = "_7o-9";
export var label = "_7o-5";
export var light = "_7o-6";
export var md = "_7o-3";
export var sm = "_7o-2";
export var thin = "_7o-8";
export var thinBold = "_7o-7";
export var vertical = "_7o-4";
export var xs = "_7o-1";